import type { CmsDataJsonApi } from '@packages/cms-components/interfaces/jsonapi';
import type { CmsImageType } from '@packages/cms-components/src/components/CmsImage/types';
import type { MbaBannerType } from '@packages/cms-components/interfaces/contentSnippet';
import { SnippetTypeList } from '@packages/cms-components/interfaces/contentSnippet';
import { useFilterTimeControl } from '@packages/cms-components/src/utils/filterTimeControl';
import { BannerItem } from './BannerItem';

export type BannerProps = {
  /** Fetched initial JSON data used to render the banner */
  bannerData?: CmsDataJsonApi;
};

/**
 * Displays linked banners on MBA pages.
 *
 * @param {Object} bannerData - Data object containing banner details
 * @returns {JSX.Element|null} Rendered banners or null if no banners are present
 */
export const Banner = ({ bannerData }: BannerProps) => {
  const filterTimeControl = useFilterTimeControl();

  const filteredItems = bannerData?.data?.filter(
    (item) =>
      item.type === SnippetTypeList.contentBannerMba &&
      item.field_paragraph?.type !== 'paragraph--minibanner' &&
      filterTimeControl(item),
  );

  return filteredItems && filteredItems.length > 0
    ? filteredItems.map((item, index) => (
        <BannerItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          data={(item as MbaBannerType).field_paragraph as CmsImageType}
        />
      ))
    : null;
};
